/**
 * Rakuten: Get Cash Back For Shopping
 *
 * 78 static resources exposed to every origin.
 * Manifest verified against version 26.13.0.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'chhjbpecpncaggjpdakmflnfcopglcmi';
export const rakuten: ExtensionDefinition = {
  id: ID,
  name: 'Rakuten: Get Cash Back For Shopping',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  signals: [
    { id: 'war-content-css', kind: 'web-accessible-resource',
      description: 'Fetch css/content.css — the injected cashback banner stylesheet.',
      weight: 1, run: () => probeFetch(ID, 'css/content.css') },
    { id: 'war-merchant-js', kind: 'web-accessible-resource',
      description: 'Fetch js/content/merchant.js — the merchant-detection script.',
      weight: 0.5, run: () => probeFetch(ID, 'js/content/merchant.js') },
  ],
};
